module.exports = __webpack_public_path__ + "static/media/kjv.6baf027c.jpg";